export default "__VITE_ASSET__kiLbF8Ex__"